import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { resetPasswordRequest, } from '../../service/resetPassword/resetPassword.js';
import { updateTwoStepActiveState } from '../TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
import { isTwoStep } from '../../tracking/helpers/constants.js';
export const initialResetPasswordState = {
    email: {
        value: '',
        error: false,
        errorMessage: '',
    },
    emailSent: false,
    isLoading: false,
    errorStatus: null,
};
export const resetPasswordThunk = createAsyncThunk('resetPassword/resetPasswordRequest', async (email, { rejectWithValue, dispatch, getState }) => {
    const state = getState();
    const resetEmailResponse = await resetPasswordRequest({ email });
    const { activeModalType } = state.wrappers.modal;
    const { activeForm } = state.core.navigation;
    // TODO: rewrite it in the future - to not use this kind of if statement.
    // It is for fullscreenTwoStep with lazy and suspense.
    if (isTwoStep(activeModalType) ||
        activeForm === 'basicTwoStep' ||
        activeForm === 'fullscreenTwoStep') {
        dispatch(updateTwoStepActiveState('resetPasswordSuccess'));
    }
    if ('error' in resetEmailResponse) {
        return rejectWithValue(resetEmailResponse);
    }
    return resetEmailResponse;
});
export const resetPasswordSlice = createSlice({
    name: 'resetPassword',
    initialState: initialResetPasswordState,
    reducers: {
        updateEmail: (state, actions) => {
            state.email.value = actions.payload;
        },
        updateEmailError: (state, actions) => {
            state.email.error = actions.payload;
        },
        updateEmailErrorMessage: (state, actions) => {
            state.email.errorMessage = actions.payload;
        },
        refreshResetPasswordState: (state) => {
            state.emailSent = false;
        },
        setIsLoading: (state, actions) => {
            state.isLoading = actions.payload;
        },
        clearResetPasswordInput: (state) => {
            state.email.error = false;
            state.email.errorMessage = '';
            state.errorStatus = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(resetPasswordThunk.pending, (state) => {
            state.isLoading = true;
        })
            .addCase(resetPasswordThunk.fulfilled, (state) => {
            state.isLoading = false;
            state.emailSent = true;
        })
            .addCase(resetPasswordThunk.rejected, (state, action) => {
            const { status } = action.payload;
            state.errorStatus = status;
            state.isLoading = false;
        });
    },
});
export const { updateEmail, setIsLoading, updateEmailErrorMessage, updateEmailError, refreshResetPasswordState, clearResetPasswordInput, } = resetPasswordSlice.actions;
const resetPasswordState = (state) => state.forms.resetPassword;
export const emailSelector = createSelector(resetPasswordState, ({ email }) => email);
export const isEmailSentSelector = createSelector(resetPasswordState, ({ emailSent }) => emailSent);
export const isLoadingSelector = createSelector(resetPasswordState, ({ isLoading }) => isLoading);
export const errorStatusSelector = createSelector(resetPasswordState, ({ errorStatus }) => errorStatus);
export const trackingResetPasswordStateSelector = createSelector(resetPasswordState, ({ emailSent }) => emailSent ? 'resetPasswordAttempted' : 'resetPasswordEnterEmailForm');
export default resetPasswordSlice.reducer;
//# sourceMappingURL=resetPasswordSlice.js.map